import React, { useState } from "react"
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisV } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"

import { ManageMeetingDisplayDialog } from "./ManageMeetingDisplayDialog"
import { toMenuMeeting } from "./meetingAttendees"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { useHoverMenu } from "../../../../../../shared/hooks/useHoverMenu"
import {
    AdditionalEventMenuItem,
    MeetingCardMenu,
} from "../../../../../nonAdminUser/reports/home/components/upcomingOrders/meetings/MeetingCardMenu"
import { MeetingDetailsOrder } from "../../meetings/meetingTypes"
import { ServiceCenterBooking } from "../../serviceCenterHomeTypes"

const useStyles = makeStyles()(() => ({
    header: {
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
    },
    title: {
        fontWeight: "bold",
        fontSize: "1.5rem",
    },
    orderId: {
        verticalAlign: "baseline",
        color: tailwindPalette.slate[500],
        marginLeft: "0.5rem",
    },
    actionButton: {
        width: "2rem",
        height: "2rem",
        color: "black",
        borderRadius: "0.75rem",
        border: `1px solid ${tailwindPalette.slate["300"]}`,
    },
}))

type MeetingHeaderProps = {
    orderId?: number
    meetingData?: MeetingDetailsOrder
    meetings?: ServiceCenterBooking[]
    onClose?: () => void
}

export const MeetingHeader: React.FC<MeetingHeaderProps> = ({ meetingData, orderId, onClose }) => {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const hoverMenu = useHoverMenu()
    const meetingName = meetingData?.meetingDetails.meetingName

    const [isManageMeetingOpen, setMeetingOpen] = useState(false)

    const additionalMenuItems: AdditionalEventMenuItem[] = [
        {
            key: "manageDisplay",
            label: l10n.getString(
                "service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display",
            ),
            onClick: () => setMeetingOpen(true),
        },
    ]

    return (
        <Box className={classes.header}>
            <Box>
                <Typography variant="h5" component="h1" className={classes.title}>
                    {meetingName}
                    <Typography component="span" className={classes.orderId}>
                        #{orderId}
                    </Typography>
                </Typography>
            </Box>
            <Stack direction="row" spacing=".5rem">
                <IconButton size="small" className={classes.actionButton} onClick={hoverMenu.handleOpen}>
                    <FontAwesomeIcon icon={faEllipsisV} />
                </IconButton>
                {meetingData && (
                    <MeetingCardMenu
                        menuOnApi
                        meeting={toMenuMeeting(meetingData)}
                        anchorEl={hoverMenu.anchorEl}
                        handleMenuClose={hoverMenu.handleClose}
                        additionalMenuItems={additionalMenuItems}
                        onOrderDeleted={onClose}
                    />
                )}
            </Stack>

            <ManageMeetingDisplayDialog
                isOpen={isManageMeetingOpen}
                orderId={orderId}
                meetingName={meetingName}
                isExternal={meetingData?.meetingDetails.isExternal}
                handleClose={() => {
                    hoverMenu.handleClose()
                    setMeetingOpen(false)
                }}
            />
        </Box>
    )
}
